var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEliminar24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45058 9.18418C3.23485 7.56321 4.39146 5.25 6.41767 5.25H17.5822C19.6084 5.25 20.765 7.56321 19.5493 9.18418C19.0304 9.87601 18.7499 10.7175 18.7499 11.5823V20C18.7499 21.5188 17.5187 22.75 15.9999 22.75H7.99995C6.48117 22.75 5.24995 21.5188 5.24995 20V11.5823C5.24995 10.7175 4.96946 9.87601 4.45058 9.18418ZM6.41767 6.75C5.62753 6.75 5.1765 7.65206 5.65058 8.28418C6.36419 9.23566 6.74995 10.3929 6.74995 11.5823V20C6.74995 20.6904 7.30959 21.25 7.99995 21.25H15.9999C16.6903 21.25 17.2499 20.6904 17.2499 20V11.5823C17.2499 10.3929 17.6357 9.23566 18.3493 8.28418C18.8234 7.65206 18.3724 6.75 17.5822 6.75H6.41767Z",
    fill: "#FF655A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 10.25C14.4142 10.25 14.7499 10.5858 14.7499 11V17C14.7499 17.4142 14.4142 17.75 13.9999 17.75C13.5857 17.75 13.2499 17.4142 13.2499 17V11C13.2499 10.5858 13.5857 10.25 13.9999 10.25Z",
    fill: "#FF655A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99995 10.25C10.4142 10.25 10.7499 10.5858 10.7499 11L10.7499 17C10.7499 17.4142 10.4142 17.75 9.99995 17.75C9.58574 17.75 9.24995 17.4142 9.24995 17L9.24995 11C9.24995 10.5858 9.58574 10.25 9.99995 10.25Z",
    fill: "#FF655A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83259 4.13037C8.2069 3.00743 9.25778 2.25 10.4415 2.25H13.5584C14.7421 2.25 15.793 3.00743 16.1673 4.13037L16.7115 5.76283C16.8424 6.15579 16.6301 6.58053 16.2371 6.71151C15.8442 6.8425 15.4194 6.63013 15.2884 6.23717L14.7443 4.60472C14.5741 4.09429 14.0965 3.75 13.5584 3.75H10.4415C9.90343 3.75 9.42576 4.09429 9.25561 4.60472L8.71146 6.23717C8.58048 6.63013 8.15574 6.8425 7.76278 6.71151C7.36982 6.58053 7.15745 6.15579 7.28844 5.76283L7.83259 4.13037Z",
    fill: "#FF655A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminar24X24);
export default __webpack_public_path__ + "static/media/ELIMINAR_24X24.d9685f1b3df43679cf74a8d9d464929e.svg";
export { ForwardRef as ReactComponent };